export default function RouteFallback() {
  return (
    <section className="flex flex-col gap-6">
      <div className="panel panel-elevated animate-fade-up px-6 py-8 sm:px-10">
        <div className="flex flex-col gap-3">
          <div className="h-3 w-24 rounded bg-white/10" />
          <div className="h-8 w-48 rounded bg-white/10" />
          <div className="mt-4 flex flex-col gap-2">
            <div className="h-4 w-full rounded bg-white/10" />
            <div className="h-4 w-11/12 rounded bg-white/10" />
            <div className="h-4 w-9/12 rounded bg-white/10" />
          </div>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, idx) => (
          <div key={idx} className="panel-inset h-28 animate-fade-up" />
        ))}
      </div>
    </section>
  )
}

